import {DataFetcher} from '@aboutyou/data-fetcher';
import {COLORS, SkeletonBlock, Z_INDEXES} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {RowSectionStyled} from '../RowSectionStyled';
import {META_BAR_HEIGHT} from '../constants';
import {useMetaBarSection} from '../hooks/useGetHeaderBulkSection';
import {MetaBarContentView} from './MetaBarView';

export const MetaBar: React.FC = () => {
  return (
    <Wrapper data-testid="headerMetaBar">
      <ContentsWrapper>
        <MetaBarContent />
      </ContentsWrapper>
    </Wrapper>
  );
};

const MetaBarContent = () => {
  return (
    <DataFetcher
      request={useMetaBarSection()}
      Loading={Skeleton}
      View={MetaBarContentView}
      Error={() => null}
    />
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: ${META_BAR_HEIGHT}px;
  background-color: ${COLORS.Grey4};
  position: relative;
  z-index: ${Z_INDEXES.DESKTOP_HEADER_METABAR};
`;

const ContentsWrapper = styled(RowSectionStyled)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  background-color: ${COLORS.Grey4};
  margin: auto;
`;
const Skeleton = () => {
  return <SkeletonBlock $height={`${META_BAR_HEIGHT}px`} disableSpaceBelow />;
};
